import { selectCommunityInfo } from "@/entities/community"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import { CommunityStatistics } from "@/widgets/community-statistics"
import { CommunicationServices } from "@/widgets/communication-services"
import { PartnerSales } from "@/widgets/partner-sales"
import { CompanyTransactionsStatistics } from "@/widgets/company-transactions-statistics"
import { useEffect } from "react"
import { 
    fetchDashboardStatus, 
    selectOnboardingVerificationStatus 
} from "@/entities/onboarding"
import { useNavigate } from "react-router-dom"

export const MainPage = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const communityInfo = useAppSelector(selectCommunityInfo)
    const verificationStatus = useAppSelector(selectOnboardingVerificationStatus)

    useEffect(() => {
        if (communityInfo?.type === "company") {
            dispatch(fetchDashboardStatus())
        }
    }, [dispatch, communityInfo?.type])

    return (
        <div className="_page_container">
            <PageHeader title="Главная" />
            
            {communityInfo.type === "company" && verificationStatus === 'draft' && (
                <div className="mb-4 p-4 flex items-center bg-yellow-100 border-b-2 rounded-lg border-yellow-500 cursor-pointer hover:bg-yellow-200 transition-colors" onClick={() => navigate('/company-profile')}>
                    <div className="text-color-dark">
                        ⚠️ Профиль вашей организации не подтверждён. Для завершения регистрации перейдите на вкладку «Профиль» и заполните данные контактного лица.
                    </div>
                </div>
            )}

            {communityInfo.type === "partner" &&
                <>
                    <PartnerSales />
                    <div className="bg-[#D3D3D3] w-full h-[1px] my-8" />
                </>
            }
            {communityInfo.type === "company" &&
                <>
                    <CompanyTransactionsStatistics />
                    <div className="bg-[#D3D3D3] w-full h-[1px] my-8" />
                </>
            }
            <CommunityStatistics />
            <CommunicationServices />
        </div>
    )
}
